import React from "react"
import { Transformation } from "cloudinary-react"
import Section from "./section"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbImage from "../ui-kit/dfb_image"
import DfbRte from "../ui-kit/dfb_rte"

const MIllustrationCopy = props => {
  return (
    <Section
      baseClass="m-IllustrationCopy "
      className={!!props.hideBorder ? "m-IllustrationCopy--border" : ""}
      defaultPaddingTop="small"
      data={props}
    >
      {props.data.headline && (
        <div className="m-IllustrationCopy-wrapper">
          <div className="m-IllustrationCopy-container">
            <DfbHeadline
              headline={props.data.headline}
              headline_level="h3"
              add_class="c-Headline-strokeLine"
            />
          </div>
        </div>
      )}
      {props.data.images &&
        props.data.images.map((item, index) => (
          <div className="m-IllustrationCopy-wrapper" key={index}>
            <div className="m-IllustrationCopy-content">
              {item.image && (
                <div className="m-IllustrationCopy-illustration">
                  <DfbImage image={item.image[0]} aspect_ratio="1:1">
                    <Transformation
                      crop="fill"
                      gravity="faces:center"
                      width="300"
                      height="300"
                      quality="auto"
                      fetchFormat="auto"
                    />
                  </DfbImage>
                </div>
              )}
              <div className="m-IllustrationCopy-text">
                {item.image_headline && (
                  <DfbHeadline
                    headline={item.image_headline}
                    headline_level="h4"
                    add_class="m-IllustrationCopy-item-headline"
                  />
                )}
                {item.image_description && (
                  <DfbRte text={item.image_description} />
                )}
              </div>
            </div>
          </div>
        ))}
    </Section>
  )
}

export default MIllustrationCopy
